function Plus2(props)
{
    return(
        <svg className={props.class} style={{...props.style}} viewBox="0 0 480 480"><path d="M400 160h-80V80a80 80 0 0 0-160 0v80H80a80 80 0 0 0 0 160h80v80a80 80 0 0 0 160 0v-80h80a80 80 0 0 0 0-160Z"></path></svg>
    )
}

export default Plus2